/**
 * <UtilHeader />
 *
 * Fixed absolute header that sticks to the container
 * 
 * @parent anybody
 * @children 
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import './UtilHeader.scss';

class UtilHeader extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    return (
      <div className='util-header'>
        {this.props.children}
      </div>
    )
  }
}

export default UtilHeader;



// WEBPACK FOOTER //
// ./src/components/UI/UtilHeader/index.js